import {Config} from "../../config/Config";

const settings: Config = require('../../config/config.json');
const axios = require('axios');

export default class FileService {
    protected request: any;
    protected accessToken: string | undefined;

    public setToken(accessToken: string | undefined) {
        this.accessToken = accessToken
        this.refreshInterceptor()
    }

    public constructor(accessToken: string | undefined) {
        this.accessToken = accessToken
        this.request = axios.create({
            baseURL: settings.restApiPath + '/repository'
        });
        this.refreshInterceptor()
    }

    private refreshInterceptor() {
        //interceptor for axios
        this.request.interceptors.request.use(
            (config: { headers: { Authorization: string; }; }) => {
                config.headers.Authorization = `Bearer ${this.accessToken}`
                return config;
            },
            (error: any) => Promise.reject(error),
        );
    }

    public getDiploma = (uuid: string) => this.request.get('/diploma/' +uuid, {responseType: 'arraybuffer'})
    public postDiploma = (data: any) => this.request.post('/diploma', data)
}